import React, { useRef } from 'react'
import { makeStyles } from '@mui/styles'
import SearchButton from '@/modules/base/components/search/button/search-button'
import MenuBar from '@/modules/layout/components/menuV2/menu-bar/menu-bar'
import ThemeInterface from '@/theme-interface'
import TenantSelectionDisplay from '@/modules/base/components/tenant-selection/tenant-selection-display'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'grid',
    gridTemplateAreas: '"leftArea centerArea rightArea"',
    gridTemplateColumns: '1fr auto 1fr',
    background: theme.navBackgroundColor,
    padding: '0px 30px',
  },
  leftArea: {
    gridArea: 'leftArea',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  centerArea: {
    gridArea: 'centerArea',
  },
  rightArea: {
    gridArea: 'rightArea',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  searchButton: {
    padding: 10,
    marginLeft: -10,
    width: 'auto',
    '& .SVGInline-svg': {
      height: 16,
      width: 16,
    },
  },
}), { name: 'NavBar' })

const NavBar = () => {
  const classes = useStyles()
  const searchStyles = useRef({ root: classes.searchButton })
  const searchIconSize = useRef({ height: 16, width: 16 })

  return (
    <div className={classes.root}>
      <div className={classes.leftArea}>
        <SearchButton
          iconSize={searchIconSize.current}
          hideActiveIcon={true}
          styles={searchStyles.current} />
      </div>
      <div className={classes.centerArea}>
        <MenuBar />
      </div>
      <div className={classes.rightArea}>
        <TenantSelectionDisplay />
      </div>
    </div>
  )
}

export default NavBar
